import request from '@/utils/request'

const prefix = '/django_rest/onboarding-management'
export default {
  searchQuestion: (condition) => {
    return request.get(`${prefix}/question/`, { params: condition })
  },
  getQuestionById: (id) => {
    return request.get(`${prefix}/question/${id}`)
  },
  createQuestion: (question) => {
    return request.post(`${prefix}/question/`, question)
  },
  updateQuestion: (question) => {
    return request.put(`${prefix}/question/${question.id}`, question)
  },

  searchStep: (condition) => {
    return request.get(`${prefix}/step/`, { params: condition })
  },
  getStepById: (id) => {
    return request.get(`${prefix}/step/${id}`)
  },
  createStep: (step) => {
    return request.post(`${prefix}/step/`, step)
  },
  updateStep: (step) => {
    return request.put(`${prefix}/step/${step.id}`, step)
  },

  searchQuestionnaire: (condition) => {
    return request.get(`${prefix}/questionnaire/`, { params: condition })
  },
  getQuestionnaireById: (id) => {
    return request.get(`${prefix}/questionnaire/${id}`)
  },
  createQuestionnaire: (questionnaire) => {
    return request.post(`${prefix}/questionnaire/`, questionnaire)
  },
  updateQuestionnaire: (questionnaire) => {
    return request.put(`${prefix}/questionnaire/${questionnaire.id}`, questionnaire)
  },

  searchMicroSite: (condition) => {
    return request.get(`${prefix}/microsite/`, { params: condition })
  },
  getMicroSiteById: (id) => {
    return request.get(`${prefix}/microsite/${id}`)
  },
  getMicroSitePageConfigById: (id) => {
    return request.get(`${prefix}/microsite/${id}`, { params: { need_detail: true } })
  },
  createMicroSite: (microSite) => {
    return request.post(`${prefix}/microsite/`, microSite)
  },
  updateMicroSite: (microSite) => {
    return request.put(`${prefix}/microsite/${microSite.id}`, microSite)
  },

  searchEmailTemplate: (condition) => {
    return request.get(`${prefix}/email/`, { params: condition })
  },
  getEmailTemplateById: (id) => {
    return request.get(`${prefix}/email/${id}`)
  },
  sendTestEmail: (emailTemplate) => {
    return request.post(`${prefix}/email/${emailTemplate.id}`, emailTemplate)
  },
  updateEmailTemplate: (emailTemplate) => {
    return request.put(`${prefix}/email/${emailTemplate.id}`, emailTemplate)
  },
  putInvitation: (invitation) => {
    return request.put(`${prefix}/invitation/`, invitation)
  },
  createInvitation: (invitation) => {
    return request.post(`${prefix}/invitation/`, invitation)
  },
  createExportOnboardingInvitationTask: (condition) => {
    return request.post(`${prefix}/export-invitation`, condition)
  },
  getExportOnboardingInvitationTaskStatus: (params) => {
    return request.get(`${prefix}/export-invitation`, { params })
  },
  exportInvitation: (condition) => {
    return request.get(`${prefix}/export-invitation`, { params: condition })
  },
  searchInvitation: (condition) => {
    return request.get(`${prefix}/invitation`, { params: condition })
  }
}
